var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_c('TextMessageDashboard',{staticClass:"txt"}),_c('OperatorMessage',{staticClass:"op"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }